<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { Sky } from 'three/examples/jsm/objects/Sky'
import { Vector3 } from 'three'
export default {
  mixins: [O3DG2],
  data () {
    return {
    }
  },
  async mounted () {
    let sky = new Sky()
    sky.scale.setScalar(45000)
    this.o3d.add(sky)

    var effectController = {
      // turbidity: 10,
      // rayleigh: 0.729,
      // mieCoefficient: 0.005,
      // mieDirectionalG: 0.7,
      // inclination: 0.128, // elevation / inclination
      // azimuth: 0.25, // Facing front,

      turbidity: 10,
      rayleigh: 3,
      mieCoefficient: 0.005,
      mieDirectionalG: 0.7,
      inclination: 0.49, // elevation / inclination
      azimuth: 0.25, // Facing front,
      exposure: 1.0
    }

    let sun = new Vector3()

    let guiChanged = () => {
      var uniforms = sky.material.uniforms
      uniforms['turbidity'].value = effectController.turbidity
      uniforms['rayleigh'].value = effectController.rayleigh
      uniforms['mieCoefficient'].value = effectController.mieCoefficient
      uniforms['mieDirectionalG'].value = effectController.mieDirectionalG

      var theta = Math.PI * (effectController.inclination - 0.5)
      var phi = 2 * Math.PI * (effectController.azimuth - 0.5)

      sun.x = Math.cos(phi)
      sun.y = Math.sin(phi) * Math.sin(theta)
      sun.z = Math.sin(phi) * Math.cos(theta)

      uniforms['sunPosition'].value.copy(sun)

      this.ctx.renderer.toneMappingExposure = effectController.exposure
    }
    guiChanged()

    // this.ctx.gui.add(effectController, 'turbidity', 0.0, 20.0, 0.1 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'rayleigh', 0.0, 4, 0.001 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'mieCoefficient', 0.0, 0.1, 0.001 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'mieDirectionalG', 0.0, 1, 0.001 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'inclination', 0, 1, 0.0001 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'azimuth', 0, 1, 0.0001 ).onChange(guiChanged)
    // this.ctx.gui.add(effectController, 'exposure', 0, 1, 0.0001 ).onChange(guiChanged)
  }
}
</script>

<style>

</style>